module.exports = __webpack_public_path__ + "img/pop-infected.066c2a02.svg";